import { Modal } from 'antd'

export const showLeaveModal = ({ onModalClose }) =>
  Modal.confirm({
    title: 'Are you sure you want to leave?',
    content: "You will lose the information you've entered if you leave now.",
    onOk() {
      Modal.destroyAll()
      onModalClose()
    },
    onCancel() {
      Modal.destroyAll()
    },
    okText: 'Leave',
    cancelText: 'Keep Editing',
    centered: true,
    style: { minWidth: '430px' },
    styles: { container: { padding: '32px 32px 24px' } }
  })
